<form  [formGroup]="formDirecciones" (ngSubmit)="updateDirection()"  class="p-3">
    <h5 class="mt-3 w-100">{{ 'PROFILE.ADDRESS_TITLE' | translate:{ index: index + 1 } }}</h5>
    <div class="row w-100 mt-3">
        <div class="col-sm-4 mt-3">
            <label>{{ 'TRAMITE.FORM.LABEL.TIPO_DE_VIA' | translate }}</label>
            <select formControlName="tipovia" class="form-control" [ngClass]="{'is-invalid': submitted && this.formDirecciones.controls['tipovia'].errors}">
                <option *ngFor="let vias of TVias" [value]="vias.id">
                    {{ vias.tipovianormalizado }}
                </option>
            </select>
            <div *ngIf="submitted && this.formDirecciones.controls['tipovia'].errors" class="invalid-feedback">
                {{ 'PROFILE.VALIDATION.SELECT_FIELD' | translate }}
            </div>
        </div>
        <div class="col-sm-8 mt-3">
            <label>{{ 'TRAMITE.FORM.LABEL.NOMBRE_DE_LA_VIA' | translate }}</label>
            <input type="text" formControlName="nombrevia" class="form-control" [ngClass]="{'is-invalid': submitted && this.formDirecciones.controls['nombrevia'].errors}"/>
            <div *ngIf="submitted && this.formDirecciones.controls['nombrevia'].errors" class="invalid-feedback">
                {{ 'PROFILE.VALIDATION.STREET_NAME_REQUIRED' | translate }}
            </div>
        </div>
    </div>
    <div class="row w-100 mt-3">
        <div class="col-sm-6 mt-3">
            <label>{{ 'TRAMITE.FORM.LABEL.NUMERO_DE_LA_VIA' | translate }}</label>
            <input type="text" formControlName="numerovia" class="form-control" [ngClass]="{'is-invalid': submitted && this.formDirecciones.controls['numerovia'].errors}"/>
            <div *ngIf="submitted && this.formDirecciones.controls['numerovia'].errors" class="invalid-feedback">
                {{ 'PROFILE.VALIDATION.STREET_NUMBER_REQUIRED' | translate }}
            </div>
        </div>
        <div class="col-sm-6 mt-3">
            <label>{{ 'REGISTER.BLOCK' | translate }}</label>
            <input type="text" formControlName="bloque" class="form-control"/>
        </div>
    </div>
    <div class="row w-100 mt-3">
        <div class="col-sm-6">
            <label>{{ 'TRAMITE.FORM.LABEL.ESCALERA' | translate }}</label>
            <input type="text" formControlName="escalera" class="form-control"/>
        </div>
        <div class="col-sm-6">
            <label>{{ 'REGISTER.FLOOR' | translate }}</label>
            <input type="text" formControlName="piso" class="form-control"/>
        </div>
    </div>
    <div class="row w-100 mt-3">
        <div class="col-sm-6">
            <label>{{ 'TRAMITE.FORM.LABEL.PUERTA' | translate }}</label>
            <input type="text" formControlName="puerta" class="form-control"/>
        </div>
        <div class="col-sm-6">
            <label>{{ 'TRAMITE.FORM.LABEL.PAIS' | translate }}</label>
            <select formControlName="pais" class="form-control" [ngClass]="{'is-invalid': submitted && this.formDirecciones.controls['pais'].errors}">
                <option *ngFor="let _pais of TPais" [value]="_pais.id">
                    {{ _pais.nombre }}
                </option>
            </select>
            <div *ngIf="submitted && this.formDirecciones.controls['pais'].errors" class="invalid-feedback">
                {{ 'PROFILE.VALIDATION.SELECT_FIELD' | translate }}
            </div>
        </div>
    </div>
    <div class="row w-100 mt-3">
        <div class="col-sm-6">
            <label>{{ 'TRAMITE.FORM.LABEL.COMUNIDAD' | translate }}</label>
            <select formControlName="ccaa" class="form-control" (change)="onChangeProvincia($event)" [ngClass]="{'is-invalid': submitted && this.formDirecciones.controls['ccaa'].errors}">
                <option *ngFor="let ccaa of TComunidades" [value]="ccaa.id">
                    {{ ccaa.nombre }}
                </option>
            </select>
            <div *ngIf="submitted && this.formDirecciones.controls['ccaa'].errors" class="invalid-feedback">
                {{ 'PROFILE.VALIDATION.SELECT_FIELD' | translate }}
            </div>
        </div>
        <div class="col-sm-6">
            <label>{{ 'TRAMITE.FORM.LABEL.PROVINCIA' | translate }}</label>
            <select formControlName="provincia" class="form-control" (change)="onChangeMunicipio($event)" [ngClass]="{'is-invalid': submitted && this.formDirecciones.controls['provincia'].errors}">
                <option *ngFor="let provincia of TProvincias" [value]="provincia.id">
                    {{ provincia.nombre }}
                </option>
            </select>
            <div *ngIf="submitted && this.formDirecciones.controls['provincia'].errors" class="invalid-feedback">
                {{ 'PROFILE.VALIDATION.SELECT_FIELD' | translate }}
            </div>
        </div>
    </div>
    <div class="row w-100 mt-3">
        <div class="col-sm-6 mt-3">
            <label>{{ 'TRAMITE.FORM.LABEL.MUNICIPIO' | translate }}</label>
            <select formControlName="municipio" class="form-control" [ngClass]="{'is-invalid': submitted && this.formDirecciones.controls['municipio'].errors}">
                <option *ngFor="let municipio of TMunicipios" [value]="municipio.municipioPK['municipio_id']">
                    {{ municipio.nombre }}
                </option>
            </select>
            <div *ngIf="submitted && this.formDirecciones.controls['municipio'].errors" class="invalid-feedback">
                {{ 'PROFILE.VALIDATION.SELECT_FIELD' | translate }}
            </div>
        </div>
        <div class="col-sm-6 mt-3">
            <label>{{ 'TRAMITE.FORM.LABEL.CODIGO_POSTAL' | translate }}</label>
            <input type="text" mask="9{5}" formControlName="codigopostal" class="form-control"  [ngClass]="{'is-invalid': submitted && this.formDirecciones.controls['codigopostal'].errors}"/>
            <div *ngIf="submitted && this.formDirecciones.controls['codigopostal'].hasError('required')" class="invalid-feedback">
                {{ 'PROFILE.VALIDATION.POSTAL_REQUIRED' | translate }}
            </div>
            <div *ngIf="submitted && this.formDirecciones.controls['codigopostal'].hasError('pattern')" class="invalid-feedback">
                {{ 'PROFILE.VALIDATION.POSTAL_INVALID' | translate }}
            </div>
        </div>
    </div>
    <div class="row w-100 mt-3 pl-3">
        <div class="col-sm-6 mt-3">
            <div class="row d-flex">
                <input type="checkbox" formControlName="isactive" class=""/>
                <label class="col">{{ 'TRAMITE.FORM.LABEL.DESEA_GUARDAR_ESTA_DIRECCION_COMO_DIRECCION_PRINCIPAL_PARA_FUTURAS_GESTIONES' | translate }}</label>
            </div>
        </div>
    </div>
    <div class="row w-100 mt-3 pl-3">
        <div class="col-sm-12 mt-3 text-right">
        <button class="btn btn-primary" type="submit" [attr.disabled]="update?'':null">
            {{ 'PROFILE.SAVE_ADDRESS' | translate }}
        </button>
        </div>
    </div>
</form>
